import Header from "@/components/Header";
import Hero from "@/components/Hero";
import FeaturesOverview from "@/components/FeaturesOverview";
import BlogSection from "@/components/BlogSection";
import PapersSection from "@/components/PapersSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Hero />
      <FeaturesOverview />
      <BlogSection />
      <PapersSection />
      <CTASection />
      <Footer />
    </div>
  );
}
